export default "__VITE_ASSET__981e2adc__"